/* eslint-disable no-lone-blocks */
/* eslint-disable no-undef */
/* eslint-disable no-fallthrough */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { v4 } from "uuid";
import { updateTable } from "../../Redux/DataTable/actions";
import Api from "../../Server/Api";
import { alertBox } from "../Functions";

const api = new Api();



const DataTable = (props) => {
	const {
		header = [],
		options = {
			disableToolBar: false,
			allowRemove: true,
			allowBulkSelect: true,
			disablePagination: false,
			left: [],
			right: [],
		},
		renderItem,
		compactMobile,
		trClassName = ""
	} = props;

	const [tableId, setTableId] = useState(v4);
	const [searchKeyword, setsearchKeyword] = useState("");

	const new_table = {
		id: tableId,
		data: [],
		selected: [],
		options: {
			currentPage: 1,
			itemsPerPage: 10,
			endpoint: {
				url: "",
				params: {},
			},
		},
	};

	const [loading, setLoading] = useState(true);

	const tableActions = ["bulkSelect", "remove"];
	const [tableData, setTableData] = useState([]);

	const removeSelectedItem = () => {
		alertBox({
			title: "Delete Selected",
			message: "Are you sure you want to deleted the selected items?",
			btnCallback: "Yes, Delete",
			callback: (e) => {
				updateTable("delete_selected_all", null);
			},
		});
	};

	const createTable = async () => {
		setLoading(true);
		const res = await api.get({
			endpoint: options?.endpoint?.url,
			data: options?.endpoint?.params,
		});
		if (res?.results) {
			let table = {
				id: tableId,
				data: res?.results || [],
				selected: [],
				options: {
					currentPage: 1,
					itemsPerPage: 10,
					count: res?.count,
					next: res?.next,
					previous: res?.previous,
				},
			}
			const index = props?.datatable?.findIndex(e => e.id === tableId)
			if(index > -1){
				let tables = props.datatable;
				tables[index] = table;
				props?.updateTable([ ...props.datatable ]);
			}else{
				props?.updateTable([ ...(props.datatable || []), table ]);
			}
		} else {
			const data = [...(props.datatable || []), new_table];
			props.updateTable(data);
		}
		setLoading(false);
	};

	const addOrRemoveSelected = (id) => {
		updateTable("add_or_remove_selected_item", id);
	};
	const addOrRemoveAllSelected = (action) => {
		updateTable("add_or_remove_selected_item_all", action);
	};

	const isSelected = (id) => {
		let table = getTable();
		return table.selected.includes(id);
	};

	const getSelected = () => {
		return getTable().selected;
	};

	const deleteTableItem = (id) => {
		alertBox({
			title: "Delete Item",
			message: "Are you sure you want to deleted the selected item?",
			btnCallback: "Yes, Delete",
			callback: async (e) => {
				if(!options?.removeEndPoint){
					notyf.open({
						type: "error",
						message: "Delete endpoint is not specified!.",
					});
				}else{
					const res = await api.del({ endpoint: options?.removeEndPoint(id) });
					console.log("Deleted "+res)
					updateTable("delete_item_from_table", id);
				}
			},
		});
	};

	const updateTable = (action, data) => {
		let table = getTable();
		const tableIndex = props.datatable.findIndex((e) => e?.id === tableId);
		if (table) {
			switch (action) {
				case "add_new_data":
					table.data = [...table.data, ...data];
					break;

				case "update_table_options":
					table = { ...table, ...data };
					break;

				case "add_or_remove_selected_item":
					{
						let d = table.selected || [];
						if (!d.includes(data)) {
							d.push(data);
						} else {
							let index = d.indexOf(data);
							d.splice(index, 1);
						}
						table.selected = d;
					}
					break;

				case "add_or_remove_selected_item_all":
					{
						if (data)
							table.selected = table.data.map((e) => {
								return e.id;
							});
						else table.selected = [];
					}
					break;

				case "delete_item_from_table":
					{
						let _data = table.data;
						const index = _data.findIndex((e) => e.id === data);
						_data.splice(index, 1);
						// Send single delete request to delete endpoint
					}
					break;

				case "delete_selected_all":
					{
						let data = table.data;
						table.selected.map((e) => {
							const index = data.findIndex((e) => e.id === e);
							data.splice(index, 1);
						});
						// Send bulk delete request to delete endpoint
						table.data = data;
						table.selected = [];
						notyf.open({
							type: "primary",
							message: "Please be careful when driving back to home.",
						});
					}
					break;

				default:
					break;
			}

			let tables = props.datatable;
			tables[tableIndex] = table;
			props.updateTable([...tables]);
		}
	};

	const getDataTable = () => {
		const table = getTable();
		if (table?.data) return table?.data || [];
		return [];
	};

	const getTable = (init) => {
		const table = props.datatable.find((e) => e?.id === tableId);
		if (init) return table;
		if (table) return table;
		return new_table;
	};

	const isInSearch = (row) => {
		return JSON.stringify(row)
			.toLowerCase()
			.includes(searchKeyword?.toLowerCase());
	};

	const isVisible = (i, row) => {
		if (searchKeyword) return isInSearch(row);
		const x = getTableSummary();
		return i >= x.start - 1 && i < x.end;
	};

	const getTableSummary = () => {
		const table = getTable();
		const options = table?.options || {};
		let end = options?.currentPage * options?.itemsPerPage;
		const start = end - options?.itemsPerPage + 1;
		end = end > table?.data?.length ? table?.data?.length : end;
		const pageCount = Math.ceil(table?.data?.length / options?.itemsPerPage);
		return {
			id: tableId,
			endpoint: options.endpoint,
			currentPage: options?.currentPage,
			itemsPerPage: options?.itemsPerPage,
			count: table?.data?.length,
			start: start,
			end: end,
			pageCount: pageCount,
			isLastPage: table?.data?.length === end,
		};
	};

	const changeTablePage = (index, nav) => {
		let options = getTable()?.options;
		options.currentPage = nav ? options.currentPage + nav : index;
		updateTable("update_table_options", { ...options });
	};


	useEffect(() => {
		const table = getTable(true);
		if (table) {
			createTable();
		} else {
			createTable();
		}
	}, [options?.endpoint]);

	const callTableFunction = (key) => {
		switch (key) {
			case "new-data":
				updateTable("add_new_data", [{ id: 3 }, { id: 5 }]);
				return;

			default:
				break;
		}
	};

	if (loading) {
		return (
			<div className="page-content-inner">
				<style>
					{`
						.pageloader {
							z-index: 1 !important;
						}
					`}
				</style>
				<div className="simplebar-wrapper">
					<div
						id={"pageloader_table"}
						className={`pageloader is-active`}
						style={{
							position: "relative",
							height: 500,
							width: "100%",
							left: 0,
							right: 0,
						}}
					/>
				</div>
			</div>
		);
	}

	return (
		<div>
			{!options?.disableToolBar && (
				<div className="datatable-toolbar app-table">
					<div className={`field has-addons ${getSelected()?.length > 0 ? "" : "is-disabled"}`}>
						{options?.left?.map((option, i) => {
							return (
								<p className="control">
									<button
										key={v4()}
										className="button h-button"
										onClick={() => {
											if (typeof option?.action === "string") {
												callTableFunction(option.action);
											} else {
												option?.action && option?.action();
											}
										}}
									>
										{option?.icon && (
											<span className="icon is-small">
												<i aria-hidden="true" className={option?.icon} />
											</span>
										)}
										<span>{option?.name}</span>
									</button>
								</p>
							);
						})}
						{options?.allowRemove && (
							<p className="control">
								<button
									className="button h-button"
									onClick={() => removeSelectedItem()}
								>
									<span className="icon is-small">
										<i aria-hidden="true" className="fas fa-times" />
									</span>
									<span>Remove</span>
								</button>
							</p>
						)}
					</div>
					<div className="buttons">
						{options?.right?.map((option, i) => {
							return (
								<button
									key={v4()}
									className="button h-button is-primary is-elevated"
									onClick={() => {
										if (typeof option?.action === "string") {
											callTableFunction(option.action);
										} else {
											option?.action && option?.action();
										}
									}}
								>
									{option.icon && (
										<span className="icon">
											<i aria-hidden="true" className={option.icon} />
										</span>
									)}
									<span>{option?.name}</span>
								</button>
							);
						})}
					</div>
				</div>
			)}

			<div className="page-content-inner">
				{/* Datatable */}
				<div className="table-wrapper" data-simplebar="init">
					<div className="simplebar-wrapper">
						<div className="simplebar-height-auto-observer-wrapper">
							<div className="simplebar-height-auto-observer"></div>
						</div>

						<div className="simplebar-content-wrapper">
							<div className="simplebar-content min-h-500px">
								<table
									id="files-datatable"
									className={`table is-datatable is-hoverable table-is-bordered ${compactMobile ? "compactable":""}`}
								>
									<thead>
										<tr>
											{options?.allowBulkSelect && (
												<th className="select-all-check">
													<div class="control">
														<label class="checkbox is-primary is-outlined is-circle">
															<input
																type="checkbox"
																onChange={(e) =>
																	addOrRemoveAllSelected(e?.target?.checked)
																}
															/>
															<span></span>
														</label>
													</div>
												</th>
											)}
											{header.map((column, i) => {
												return (
													<th
														key={v4()}
														className={`${column?.className} data-header-th`}
														data-sort={column?.sortName}
													>
														{column?.name}
													</th>
												);
											})}
										</tr>
										{!options.disableSearch && getDataTable().length > 0 && (
											<tr class="datatable-filter-line">
												<td class="datatable-filter-cell" colSpan={9}>
													<div class="control has-icon table-search-input">
														<input
															type="text"
															placeholder="Type to Filter... "
															class="datatable-filter datatable-input-text input"
															data-filter="name"
															onInput={(e) => setsearchKeyword(e.target.value)}
														/>
														<div class="form-icon">
															<svg
																xmlns="http://www.w3.org/2000/svg"
																width="24"
																height="24"
																viewBox="0 0 24 24"
																fill="none"
																stroke="currentColor"
																stroke-width="2"
																stroke-linecap="round"
																stroke-linejoin="round"
																class="feather feather-search"
															>
																<circle cx="11" cy="11" r="8"></circle>
																<line
																	x1="21"
																	y1="21"
																	x2="16.65"
																	y2="16.65"
																></line>
															</svg>
														</div>
													</div>
												</td>
											</tr>
										)}
									</thead>

									<tbody>
										{getDataTable().length > 0 &&
											getDataTable().map((item, i) => {
												return (
													<tr
														key={v4()}
														data-id={i}
														className={`${
															isSelected(item?.id) ? "is-selected" : ""
														} ${!isVisible(i, item) ? "d-none" : ""} ${trClassName}`}
													>
														{options?.allowBulkSelect && (
															<td>
																<div class="control">
																	<label class="checkbox is-circle is-primary is-outlined">
																		<input
																			type="checkbox"
																			checked={isSelected(item?.id)}
																			onChange={(e) =>
																				addOrRemoveSelected(item?.id)
																			}
																		/>
																		<span></span>
																	</label>
																</div>
															</td>
														)}
														{renderItem &&
															renderItem({
																...item,
																deleteItem: () => deleteTableItem(item?.id),
															})}
													</tr>
												);
											})}
									</tbody>
								</table>
								{getDataTable().length < 1 && (
									<div className="section-placeholder">
										<div className="placeholder-content">
											<img
												className="light-image"
												src={
													require("../../assets/img/illustrations/placeholders/search-4.svg")
														.default
												}
												alt=""
											/>
											<img
												className="dark-image"
												src={
													require("../../assets/img/illustrations/placeholders/search-4-dark.svg")
														.default
												}
												alt=""
											/>
											<h3 className="dark-inverted">No data to show</h3>
											<p>There is currently no data to show in this list.</p>
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
				{!options?.disablePagination && getDataTable().length > 0 && (
					<div
						id="paging-first-datatable"
						className="pagination datatable-pagination pagination-datatables text-center"
					>
						<div className="datatable-info">
							<span>
								Showing {getTableSummary().start} to {getTableSummary().end} of{" "}
								{getTableSummary().count} items.
							</span>
						</div>
						<ul className="pagination">
							<li
								className={getTableSummary().currentPage === 1 ? "" : "active"}
							>
								<a
									data-page="prev"
									onClick={(e) => {
										e.preventDefault();
										if (getTableSummary().currentPage > 1) {
											changeTablePage(null, -1);
										}
									}}
								>
									<i className="fas fa-angle-left" />
								</a>
							</li>
							{new Array(getTableSummary().pageCount).fill(0).map((x, i) => {
								return (
									<li
										className={
											getTableSummary().currentPage === i + 1 ? "active" : ""
										}
									>
										<a
											href="#"
											data-page={i + 1}
											onClick={(e) => {
												e.preventDefault();
												changeTablePage(i + 1);
											}}
										>
											{i + 1}
										</a>
									</li>
								);
							})}
							<li className={!getTableSummary().isLastPage ? "active" : ""}>
								<a
									data-page="next"
									onClick={(e) => {
										e.preventDefault();
										if (!getTableSummary().isLastPage) {
											changeTablePage(null, 1);
										}
									}}
								>
									<i className="fas fa-angle-right" />
								</a>
							</li>
						</ul>
					</div>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		datatable: state.datatable.tables,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateTable: (e) => dispatch(updateTable(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(DataTable);
